import { Component, Input } from '@angular/core';
import { MatInput } from '@angular/material/input';
import { Applicant } from '@app/models/recruiting/applicant.model';
import { JobAttachment } from '@app/models/recruiting/job-attachments.model';
import { JobAttachmentTypes } from '@app/modules/applicant-tracker/enums/job-attachment-types.enum';
import { BaseForm } from '@app/modules/forms/base.form';
import { FileHelperService } from '@app/services';

@Component({
    selector: 'app-applicant-store-upload-form',
    templateUrl: './applicant-store-upload.form.html',
    styleUrls: ['./applicant-store-upload.style.scss'],
})
export class ApplicantStoreUploadForm extends BaseForm {
    @Input() applicant: Applicant;
    jobAttachmentTypes = JobAttachmentTypes;
    jobAttachments: JobAttachment[] = [];

    constructor(private fileHelper: FileHelperService) {
        super();
    }

    async loadJobAttachments(): Promise<void> {
        const [jobAttachments] = await JobAttachment.where('atsJobId', this.applicant.jobPosting.id).get();
        this.jobAttachments = jobAttachments;
    }

    async uploadFile(file: File, jobAttachment: JobAttachment): Promise<void> {
        if (!file) {
            jobAttachment.fileId = undefined;
            return;
        }

        const uploadedFile = await this.fileHelper.store(file);
        jobAttachment.fileId = uploadedFile.id;
    }

    attachLink(jobAttachment: JobAttachment, linkField: MatInput): void {
        if (!linkField.value) {
            return;
        }

        jobAttachment.link = linkField.value;
        jobAttachment.linkAttached = true;
    }

    removeLink(jobAttachment: JobAttachment): void {
        jobAttachment.link = undefined;
        jobAttachment.linkAttached = false;
    }
}
